import React from 'react';
import Container from './ui/Container';
import { useT } from '../i18n';

const T = {
  es: {
    eyebrow: 'Confían en nosotros',
    heading: 'Empresas que transforman su logística con Cadenia',
  },
  en: {
    eyebrow: 'Trusted by',
    heading: 'Companies transforming their logistics with Cadenia',
  },
};

const ClientLogos = () => {
  const t = useT(T);
  const clients = [
    { name: 'Lecta', logo: '/images/lecta-color.jpg', url: 'https://www.lecta.com' },
    { name: 'Master Builders Solutions', logo: '/images/mbs-color.jpg', url: 'https://www.master-builders-solutions.com' },
    { name: 'Polyedra', logo: '/images/polyedra-color.jpg', url: 'https://www.polyedra.com' },
    { name: 'Sika', logo: '/images/sika-color.svg', url: 'https://www.sika.com' },
    { name: 'Torraspapel', logo: '/images/torraspapel-color.png', url: 'https://www.torrasdistribucion.com/es' }
  ];

  // Duplicate for seamless loop
  const allLogos = [...clients, ...clients];

  return (
    <section className="py-20 bg-white overflow-hidden" aria-labelledby="client-logos-heading">
      <Container>
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-slate-400 uppercase tracking-widest mb-3">{t.eyebrow}</p>
          <h3 className="text-2xl md:text-3xl font-light text-slate-900">
            {t.heading}
          </h3>
        </div>
      </Container>

      {/* Marquee scroll */}
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        <div className="flex animate-marquee hover:[animation-play-state:paused]">
          {allLogos.map((c, idx) => (
            <a
              key={idx}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 mx-10 md:mx-16 flex items-center justify-center group"
              title={c.name}
            >
              <div className="px-6 py-4 rounded-xl transition-all duration-300 group-hover:bg-slate-50">
                <img
                  src={c.logo}
                  alt={c.name}
                  className="h-14 md:h-16 w-auto object-contain filter grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                  loading="lazy"
                />
              </div>
            </a>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 35s linear infinite;
          width: max-content;
        }
      `}</style>
    </section>
  );
};

export default ClientLogos;
